import React from "react";
import { Box } from "@mui/material";
import Logo from "../../assets/images/Logo.png";
import LogoDark from "../../assets/images/logo_dark.png";
import { useLocation, useHistory } from "react-router-dom";
import Btn from "../common/Button/Button";
import showNav from "../../context/scrollContext";
import useMediaQuery from "@mui/material/useMediaQuery";

function AboutNav({ theme = "light" }) {
  const location = useLocation();
  const mobMatch = useMediaQuery("(max-width:600px)");
  const history = useHistory();
  const show = React.useContext(showNav);
  const dark = theme === "dark";
  return mobMatch ? null : (
    <>
      <Box
        sx={{
          display: { xs: "none", sm: "block" },
          zIndex: "10",
          backgroundColor: dark ? "#283237" : "white",
          position: "fixed",
          top: "0",
          height: show ? "72px" : "0",
          paddingX: "18px",
          justifyContent: "space-between",
          display: "flex",
          alignItems: "center",
          borderBottom: show ? "1px solid #D6D6D6" : "",
          width: "100%",
          transition: "all 0.5s ease",
        }}
      >
        {show && (
          <>
            <Box
              sx={{
                width: "169px",
                height: "40px",
                cursor: "pointer",
                overflow: "hidden",
              }}
              onClick={() => {
                history.push("/");
              }}
            >
              <img
                src={dark ? LogoDark : Logo}
                alt="logo"
                width="169px"
                height="40px"
              />
            </Box>
            {!location.pathname.includes("/sell-with-us") ? (
              <Box
                sx={{
                  marginRight: "6px",
                }}
              >
                <Btn
                  typoVariant="subtitle2"
                  variant="outlined"
                  bgColor={dark ? "#283237" : "#FFF"}
                  txColor={dark ? "white" : "primary.main"}
                  sx={{
                    height: "36px",
                    boxShadow: "none",
                    marginRight: "24px",
                  }}
                  hoverBg={dark ? "white" : "primary.main"}
                  hoverTxColor={dark ? "#283237" : "white"}
                >
                  Sell with us
                </Btn>
                <Btn
                  variant="contained"
                  txColor="text.primary"
                  bgColor="#F9D548"
                  sx={{ height: "36px", width: "185px", boxShadow: "none" }}
                  hoverBg="#F3C04F"
                >
                  Explore Pro Machinery
                </Btn>
              </Box>
            ) : null}
          </>
        )}
      </Box>
      <Box
        sx={{
          display: { xs: "none", sm: "block" },
          border: dark ? "1px solid #283237" : "",
          width: "100%",
          backgroundColor: dark ? "#283237" : "white",
          height: "72px",
        }}
      >
        <Box
          sx={{
            width: "169px",
            height: "40px",
            cursor: "pointer",
            overflow: "hidden",
            marginLeft: "18px",
            marginY: "16px",
          }}
          onClick={() => {
            history.push("/");
          }}
        >
          <img
            src={dark ? LogoDark : Logo}
            alt="logo"
            width="169px"
            height="40px"
          />
        </Box>
      </Box>
    </>
  );
}

export default AboutNav;
